import axios from "axios";
import { baseURL } from "@/general";

const adminApi = axios.create({
  baseURL,
});

///Estancias
export const getEstanciasAlum = async () => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.get("/estancia/estanciasAlumnos", config);
    return response;
  } catch (error) {
    const response = error;
    return response;
  }
};

export const registroEstancia = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/preregistroAlumno",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error;
    return response.response;
  }
};




export const subirDocumentacion = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/subirDocumentacion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error;
    return response.response;
  }
};

export const reenviarDocumentacion = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/reenviarDocumentos",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error;
    return response.response;
  }
};

export const traeDocumentos = async () => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.get(
      "/alumno/getDocumentosReprobados",
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const verificaDocumentacion = async () => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.get("/alumno/getDocumentos", config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const traeSemestreActual = async () => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.get("/semestre/getSemestreActual", config);
    return response;
  } catch (error) {
    const response = error;
    return response;
  }
};

export const registroExternos = async (values) => {
  try {
    const response = await adminApi.post("/alumno/registro", values);
    return response;
  } catch (error) {
    const response = error;
    return response;
  }
};

export const noEsInterno = async (values) => {
  try {
    const response = await adminApi.post("alumno/noEsAlumno", values);
    return response;
  } catch (error) {
    const response = error;
    return response.response;
  }
};

export const comprobanteInscripcion = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "general/generarComprobanteEC1A",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const insertEncuestaAlumno = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "encuesta/insertEncuestaAlumno",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error.response.data;
    return response;
  }
};


export const verificaEncuesta = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "encuesta/getEncuestaAlumno",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error.response.data;
    return response;
  }
};



export const subirCartel = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/subirInformeFinal",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};

export const validaCartel = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/getInformeEvaluado",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};



export const verificaConstancia = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/validaConstancia",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};



export const generarConstanciaAlumno = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/general/generarConstanciaAlumno",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};

export const obtenerEstanciasAnteriores = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/alumno/registrosAnteriores",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error;
    return response.response.data;
  }
};


